export default __webpack_public_path__ + "static/media/giftcard-1.8729cb3d.svg";